export const Svg_080 = () => (
  <svg style={{ width: '70px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={52.5}
        x2={26.6}
        y1={6.5}
        y2={43.6}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={41.5}
        x2={27.8}
        y1={36.4}
        y2={56}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M59.4 35.9h-5c-.5 0-1 .4-1 1v2.9c-1.2-.5-2.6-.7-4-.7-1.9 0-4.4 1-6.2 1.8H43c-2.2 1-4 1.1-4.2 1.1H28.2c-1.5 0-2.9.9-3.5 2.2l-8.9-6.4c-.1 0-.2-.1-.3-.2-.1 0-2.8-.6-4.4.9-1 1-1.4 2.5-1.1 4.5 0 .2 0 .3.2.5 0 0 2.1 2.5 5.4 5.3 4.4 3.8 8.6 6.4 12.5 7.8h.1c.8.3 2.8 1 4.2 1.2.7.1 1.5.2 2.2.2 1.7 0 3.4-.3 5-.9l6-2.7c.8-.3 3.1-1.1 4-1.2 1.8-.3 3-.2 3.6-.1v5.6c0 .5.4 1 1 1h5c.5 0 1-.4 1-1V36.9c0-.5-.4-1-1-1Zm-9.8 15.4c-1.4.2-4.2 1.2-4.5 1.3l-6 2.7c-2.6.9-4.8.8-6.2.6-1.3-.2-3.2-.9-3.9-1.1h-.1c-4.6-1.6-9-4.9-11.9-7.4-1.8-1.5-3.4-3.2-5-5-.1-.9 0-1.9.5-2.5.6-.6 1.9-.5 2.4-.5l9.4 6.8c.1 2 1.8 3.7 3.9 3.7h10.7c.5 0 1-.4 1-1s-.4-1-1-1H28.2c-1.1 0-2-.9-2-2s.9-2 2-2.1h10.7s2.2 0 4.9-1.2h.2c2.5-1.2 4.3-1.7 5.4-1.7 1.5 0 2.9.3 4 .8v9.2c-1-.1-2.3 0-3.8.2Zm8.9 6.4h-3.1V37.8h3.1v19.9Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M34.2 34v4.1c0 .5.4 1 1 1s1-.4 1-1V34c1.6 0 4.6-.5 6.7-2.6s2.6-7.5 2.6-7.7c0-.5-.4-.9-.9-.9-.2 0-4.8-.2-7.7 2.6-.2.2-.5.5-.7.8v-1.3c.9-.9 3.3-3.6 3.3-7s-3.4-7.2-3.6-7.3c-.4-.3-.9-.3-1.3 0-.1.1-3.6 3.3-3.6 7.3s2.4 6.1 3.3 7v1.3c-.2-.3-.4-.5-.7-.8-2.8-2.8-7.5-2.6-7.7-2.6-.5 0-.9.4-.9.9 0 .2-.2 4.9 2.6 7.7s5.1 2.5 6.7 2.6Zm4-7.3c1.5-1.5 4-1.9 5.3-2 0 1.3-.5 3.7-2 5.3-1.5 1.5-4 1.9-5.3 2 0-1.3.5-3.7 2-5.3Zm-3.1-14c.9 1 2.3 3 2.3 5.2s-1.4 4.2-2.3 5.2c-.9-1-2.3-3-2.3-5.2s1.4-4.2 2.3-5.2Zm-3 14c1.5 1.5 1.9 4 2 5.3-1.3 0-3.7-.5-5.3-2s-1.9-4-2-5.3c1.3 0 3.7.5 5.3 2Z"
      style={{
        fill: "url(#b)",
      }}
    />
  </svg>
)